import React from 'react';
import ShowOnlyPendingRequestsCheckbox from '../../../views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ShowOnlyPendingRequestsCheckbox';
import AMultiFieldSearchInput from '../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
// import { searchInputOptions, statusFilterOptions } from '../components/searchStudent/studentTransfersListing/utils';
import { searchInputOptions } from './constant';
import { getFilterFormFields } from './constant';
import FilterForm from './FilterForm';
import AButton from '../../../views/pages/manage/common/form-fields-mui/AButton';
import APopover from '../../../views/pages/manage/common/a-popover';
import { ReactComponent as ExcelIcon } from "assets/img/svg/excel.svg";

const Filters = ({
    dropdowns,
    getApprovalRequests,
    loading,
    currPageSize,
    globalFilter,
    setGlobalFilter,
    onFilterChange,
    downloadHandler,
    userDetails
}) => {


    const searchHandler = (filters = {}) => {
        getApprovalRequests({
            filters: { ...globalFilter, ...filters },
            pageNo: 0
        })
        // onFilterChange(filters)
    }

    return (
        <div className='d-flex' style={{ gap: '0.75rem' }}>

            <ShowOnlyPendingRequestsCheckbox
                checked={globalFilter?.finalStatus?.[0]?.label === 'Pending'}
                showOnlyPendingRequestsHandler={checked => {
                    searchHandler({
                        finalStatus: checked ? [{ label: 'Pending', value: 'InProgress' }] : []
                    })
                }}
            />

            <AMultiFieldSearchInput
                options={searchInputOptions}
                isLoading={loading}
                searchHandler={(keyName, value) => searchHandler({ [keyName]: value })}
                crossHandler={(keyName, value) => searchHandler({ [keyName]: value })}
            />

            <APopover
                buttonComponent={(openPopover, styles) => (
                    <AButton
                        className="tiny-semi-bold color-dark no-ml-btn"
                        onClick={openPopover}
                        size="xs"
                        updatedStyle={{
                            minWidth: "61px",
                            ...(globalFilter?.appliedFilterCount > 0
                                ? {
                                    border: "1px solid #00B0F5",
                                    color: "#00B0F5",
                                }
                                : styles),
                        }}
                    >
                        Filters {globalFilter?.appliedFilterCount || ''}
                        {/* {filterCount > 0 ? `(${filterCount})` : ""} */}
                    </AButton>
                )}
                menuComponent={(closePopup) =>
                    <FilterForm
                        closePopup={closePopup}
                        dropdownData={dropdowns}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                        searchHandler={searchHandler}
                        currPageSize={currPageSize}
                        formFields={
                            getFilterFormFields(dropdowns)
                        }
                    />
                }
            />
            <AButton
                onClick={() => { downloadHandler(globalFilter, userDetails, dropdowns) }}
                variant='outline'
                outlineVariantColor='#CCC'
                textColor='#0F0F0F'
                size='xs'
                className='no-ml-btn'
            >
                <ExcelIcon className='mr-1' />
                Download
            </AButton>

        </div>
    );
}

export default Filters;